import { PlusOutlined } from '@ant-design/icons';
import { Drawer, ScrollArea } from '@mantine/core';
import { useIntersection } from '@mantine/hooks';
import { Tabs } from 'antd';
import ConfirmPopup from 'components/Atoms/LoyaltyStore/ConfirmPopup';
import Location from 'components/Atoms/LoyaltyStore/Location';
import AvaiableGift from 'components/Atoms/LoyaltyStore/MyGiftModal/AvaiableGift';
import DeliveringGift from 'components/Atoms/LoyaltyStore/MyGiftModal/DeliveringGift';
import { RenderHTML } from 'components/Atoms/LoyaltyStore/RenderHtml';
import { TabsStyle } from 'components/Molecules/LoyaltyStore/MyGiftModal/style';
import { RoutesV1 } from 'constants/appRoutes';
import { dateFormat, getAuth, isNullOrEmpty, isPending } from 'functions';
import useDevice from 'hooks/useDevice';
import { genLinkBhbv } from 'model/services/LoyaltyAccountInfoService';
import { updateStatusGiftInforServ } from 'model/services/LoyaltyGiftService';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { formatTimeString, format_curency } from 'utils';

export const cvMaSanpham = (value) => {
  switch (value) {
    case 'bảo hiểm tnds xe mô tô 2 bánh dung tích trên 50 cc':
      return 'BHXM1';
    case 'bảo hiểm tnds xe ô tô không kinh doanh vận tải dưới 6 chỗ ngồi':
      return 'TNDSOTO1';
    case 'bảo hiểm tnds xe ô tô không kinh doanh vận tải từ 6- 11 chỗ ngồi':
      return 'TNDSOTO2';
    default:
      return value;
  }
};

const ModalDetailUseGift = ({
  type,
  data,
  statusGift,
  handleClose,
  handleStatusGift,
  reloadData,
}) => {
  const eGiftEmpty = isNullOrEmpty(data.eGift);
  const { date, month, year } = formatTimeString(
    !eGiftEmpty ? data.eGift.expiredDate : new Date().toISOString()
  );
  const infoProfile = useSelector((state) => state.userProfile.data);

  const { giftTransaction, imageLinks, eGift } = data;

  // const [intro = '', condition = '', location = ''] = giftTransaction?.introduce
  //   ? giftTransaction?.introduce?.split('**')
  //   : '';
  const isMobile = useDevice().isMobile;
  const navigate = useNavigate();

  const [tabActive, setTabActive] = useState('1');
  const [isOpen, setIsOpen] = useState(false);
  const [isFocus, setIsFocus] = useState(1);
  const [isShowTabBubble, setShowTabBubble] = useState(false);

  const infoRef = useRef();
  const conditionRef = useRef();
  const locationRef = useRef();

  const { ref, entry } = useIntersection({
    threshold: 0.2,
  });
  const { ref: infoRefFocus, entry: entryInfoFocus } = useIntersection({
    threshold: 0.5,
  });
  const { ref: conditionRefFocus, entry: entryConditionFocus } = useIntersection({
    threshold: 0.5,
  });
  const { ref: locationRefFocus, entry: entryLocationFocus } = useIntersection({
    threshold: 0.5,
  });

  const handleChangeGift = (type) => {
    const payload = { giftRedeemTransactionCode: giftTransaction.code };
    handleStatusGift((prev) => {
      return {
        ...prev,
        isLoading: true,
      };
    });

    updateStatusGiftInforServ(payload)
      .then((res) => {
        if (res.responseMessage === 'Success') {
          handleStatusGift((prev) => {
            return {
              ...prev,
              isLoading: false,
            };
          });
          if (type == 'delivery') {
            handleClose('delivery');
            navigate(`${RoutesV1.loyaltyStore}#openGift=true&open=used`);
          }
          reloadData();
        } else {
          handleStatusGift((prev) => {
            return {
              ...prev,
              isFail: true,
              isLoading: false,
              reason: res.obj?.message,
            };
          });
        }
        setIsOpen(false);
      })
      .catch((err) => {
        handleStatusGift((prev) => {
          setIsOpen(false);
          return {
            ...prev,
            isFail: true,
            isLoading: false,
            reason: err,
          };
        });
      });
  };
  const fillInInformation = () => {
    handleStatusGift((prev) => {
      return {
        ...prev,
        isLoading: true,
      };
    });
    const payload = {
      hoTen: infoProfile?.userName,
      ngaySinh: dateFormat(infoProfile?.clientDateOfBirth),
      canCuoc: infoProfile?.userClientIdnumber,
      soDienThoai: infoProfile?.userMobifone,
      maGiamGia: giftTransaction.code,
      ngayBatDau: dateFormat(eGift.creationTime),
      ngayKetThuc: dateFormat(eGift.expiredDate),
      userCode: infoProfile?.userCode,
      maSanPham: cvMaSanpham(giftTransaction.giftName.toLowerCase()),
    };
    genLinkBhbv(payload)
      .then((res) => {
        if (+res.responseStatus === 1) {
          handleStatusGift((prev) => {
            return {
              ...prev,
              isLoading: false,
            };
          });
          window.open(res.obj.linkMuaSanPham);
          setIsOpen(false);
        } else {
          handleStatusGift((prev) => {
            return {
              ...prev,
              isFail: true,
              isLoading: false,
              reason: res.responseMessage,
            };
          });
        }
        setIsOpen(false);
      })
      .catch((err) => {
        console.log(err);

        handleStatusGift((prev) => {
          setIsOpen(false);
          return {
            ...prev,
            isFail: true,
            isLoading: false,
            reason: err,
          };
        });
      });
  };

  const processing = isPending(statusGift.isLoading);

  useEffect(() => {
    if (entry) {
      setShowTabBubble(!entry.isIntersecting);
    }
    if (entryInfoFocus?.isIntersecting) {
      setIsFocus(1);
    }
    if (entryConditionFocus?.isIntersecting) {
      setIsFocus(2);
    }
    if (entryLocationFocus?.isIntersecting) {
      setIsFocus(3);
    }
  }, [entry, entryInfoFocus, entryConditionFocus, entryLocationFocus]);

  return (
    <>
      {processing}
      {giftTransaction && (
        <>
          {isMobile ? (
            <>
              <Drawer
                opened={statusGift.isOpen}
                onClose={() => {}}
                size='xl'
                position='right'
                withCloseButton={false}
                padding={0}
                zIndex={600}
              >
                <div style={{ height: '95vh', overflow: 'scroll' }}>
                  <PlusOutlined
                    onClick={handleClose}
                    className='absolute left-4 top-4 z-50 mr-4 cursor-pointer rounded-full bg-white p-1'
                    style={{
                      color: '#000',
                      fontSize: 20,
                    }}
                    rotate={45}
                  />
                  <img
                    ref={ref}
                    src={data?.imageLinks[0]?.fullLink || ''}
                    // src='assets/images/carousel/pc/Voucher2.png'
                    className='h-[200px] w-screen object-cover'
                    alt=''
                  />
                  <div className='my-2 font-roboto-regular text-14px'>
                    <div
                      className={`sticky top-0 z-40 px-6 pb-2 ${
                        isShowTabBubble ? 'drop-shadow-lg' : ''
                      } bg-white`}
                    >
                      <p
                        className={`${
                          isShowTabBubble ? 'ml-7 pt-4' : 'ml-0'
                        } line-clamp-2 font-averta-regular text-20px transition-all ease-in-out`}
                      >
                        {giftTransaction.giftName}
                      </p>
                      <div className='mt-1 w-full'>
                        <p className='whitespace-nowrap text-0090F0'>
                          {format_curency(giftTransaction.coin)} điểm
                        </p>
                        {/* <p className='whitespace-nowrap text-14px text-7B7B7B'>
                          Hạn sử dụng:
                          <span className='font-roboto-regular text-0090F0'>
                            {date}/{month}/{year}
                          </span>
                        </p> */}
                      </div>
                      <div className='mt-3 flex justify-between'>
                        <p
                          className={`rounded-md border px-3 py-1 ${
                            isFocus === 1 ? 'border-0090F0 bg-[#E0F2FF]' : ''
                          }`}
                          onClick={() =>
                            infoRef.current.scrollIntoView({
                              behavior: 'smooth',
                            })
                          }
                        >
                          Thông tin
                        </p>
                        <p
                          className={`rounded-md border px-3 py-1 ${
                            isFocus === 2 ? 'border-0090F0 bg-[#E0F2FF]' : ''
                          }`}
                          onClick={() =>
                            conditionRef.current.scrollIntoView({
                              behavior: 'smooth',
                            })
                          }
                        >
                          Điều kiện sử dụng
                        </p>
                        <p
                          className={`rounded-md border px-3 py-1 ${
                            isFocus === 3 ? 'border-0090F0 bg-[#E0F2FF]' : ''
                          }`}
                          onClick={() =>
                            locationRef.current.scrollIntoView({
                              behavior: 'smooth',
                            })
                          }
                        >
                          Địa điểm
                        </p>
                      </div>
                    </div>
                    <div className='mx-6 mt-1'>
                      {(type == 1 ||
                        type === 3 ||
                        type === 5 ||
                        (type == 4 && giftTransaction?.eGiftCode)) &&
                        !!eGift && (
                          <div className='mb-[20px]'>
                            <div className='mb-[20px] flex justify-between'>
                              <div className='grow text-14px text-7B7B7B lg:mx-8'>
                                <div className='my-2 mt-3 flex w-full justify-between'>
                                  <p>Mã code</p>
                                  <p className='text-black'>{eGift.code}</p>
                                </div>
                                <div className='h-[2px] w-full bg-[#f1f4fb]'></div>
                                <div className='my-2 mt-3 flex w-full justify-between'>
                                  <p>Ngày xuất</p>
                                  <p className='text-black'>
                                    {moment(giftTransaction.date).format('DD/MM/YYYY')}
                                  </p>
                                </div>
                                <div className='h-[2px] w-full bg-[#f1f4fb]'></div>
                                <div className='my-2 mt-3 flex w-full justify-between'>
                                  <p>Hạn sử dụng</p>
                                  <p className='text-[#C4860B]'>
                                    {moment(eGift.expiredDate).format('DD/MM/YYYY')}
                                  </p>
                                </div>
                                <div className='h-[2px] w-full bg-[#f1f4fb]'></div>
                                <div className='my-2 mt-3 flex w-full justify-between'>
                                  <p>Hotline</p>
                                  <p className='text-[#0090F0]'>1900 299 232</p>
                                </div>
                                <div className='h-[2px] w-full bg-[#f1f4fb]'></div>
                              </div>
                            </div>
                            <div className='flex justify-center'>
                              <AvaiableGift.QR qrid={giftTransaction?.eGiftCode || ''} />
                            </div>
                          </div>
                        )}
                      <div ref={infoRefFocus}>
                        <div ref={infoRef}>
                          {type == 1 || type == 3 ? (
                            <AvaiableGift.Info
                              intro={
                                giftTransaction?.thirdPartyContent
                                  ? giftTransaction.thirdPartyContent
                                  : ''
                              }
                            />
                          ) : (
                            <DeliveringGift.Info data={data} />
                          )}
                        </div>
                      </div>
                      <div ref={conditionRefFocus}>
                        <RenderHTML
                          ref={conditionRef}
                          string={
                            giftTransaction?.thirdPartyNote ? giftTransaction.thirdPartyNote : ''
                          }
                        />
                      </div>
                      <div ref={locationRefFocus}>
                        <div ref={locationRef} className='w-full'>
                          <Location office={giftTransaction?.office || []} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {type == 3 && (
                  <DeliveringGift.Confirm handleChangeGift={() => handleChangeGift('delivery')} />
                )}
                {type == 5 && (
                  <DeliveringGift.FillInInformation fillInInformation={() => fillInInformation()} />
                )}
                <ConfirmPopup
                  isOpen={isOpen}
                  handleClose={() => {
                    setIsOpen(false);
                  }}
                  handleSubmit={handleChangeGift}
                  name={giftTransaction.giftName || ''}
                  point={giftTransaction.coin || 0}
                  quantity={giftTransaction?.quantity || 1}
                  zIndex={601}
                />
              </Drawer>
            </>
          ) : (
            <>
              <div
                className={`absolute z-[1000] h-full w-full bg-white ${
                  statusGift.isOpen ? 'top-0' : 'top-full'
                }`}
              >
                <div className='flex items-center justify-between p-4'>
                  <p className='line-clamp-2 font-averta-bold text-18px'>
                    {giftTransaction.giftName}
                  </p>
                  <div className='flex items-center'>
                    <div className='flex w-fit font-roboto-regular text-14px'>
                      <p className='whitespace-nowrap px-2 font-roboto-medium leading-18px text-0090F0'>
                        {format_curency(giftTransaction.coin)} điểm
                      </p>
                      {/* {!eGiftEmpty && (
                        <p className='whitespace-nowrap border-l-[2px] px-2 text-14px text-7B7B7B'>
                          Hạn sử dụng:{' '}
                          <span className='text-0090F0'>
                            {date}/{month}/{year}
                          </span>
                        </p>
                      )} */}
                    </div>
                    <div className='ml-2 cursor-pointer' onClick={handleClose}>
                      <PlusOutlined rotate={45} style={{ color: '#000', fontSize: '20px' }} />
                    </div>
                  </div>
                  {(type == 1 ||
                    type == 3 ||
                    type == 5 ||
                    (type == 4 && giftTransaction?.eGiftCode)) &&
                    !!eGift &&
                    tabActive === '1' && (
                      <div className='absolute right-10 top-[3.5rem] z-[1000]'>
                        <AvaiableGift.QR qrid={giftTransaction?.eGiftCode || ''} />
                      </div>
                    )}
                </div>
                <div className='px-4'>
                  <TabsStyle>
                    <Tabs defaultActiveKey={tabActive} onChange={setTabActive}>
                      <Tabs.TabPane tab='Thông tin' key='1'>
                        <ScrollArea style={{ height: '380px' }}>
                          {(type == 1 ||
                            type == 3 ||
                            type == 5 ||
                            (type == 4 && giftTransaction?.eGiftCode)) &&
                            !!eGift && (
                              <div className='mb-[20px] flex flex-col items-center'>
                                <img
                                  src={imageLinks[0]?.fullLink || ''}
                                  className='w-[350px]'
                                  alt=''
                                />
                                <div className='w-[350px] grow text-14px text-7B7B7B'>
                                  <div className='my-2 mt-3 flex w-full justify-between'>
                                    <p>Mã code</p>
                                    <p className='text-black'>{eGift.code}</p>
                                  </div>
                                  <div className='h-[2px] w-full bg-[#f1f4fb]'></div>
                                  <div className='my-2 mt-3 flex w-full justify-between'>
                                    <p>Ngày xuất</p>
                                    <p className='text-black'>
                                      {moment(giftTransaction.date).format('DD/MM/YYYY')}
                                    </p>
                                  </div>
                                  <div className='h-[2px] w-full bg-[#f1f4fb]'></div>
                                  <div className='my-2 mt-3 flex w-full justify-between'>
                                    <p>Hạn sử dụng</p>
                                    <p className='text-[#C4860B]'>
                                      {moment(eGift.expiredDate).format('DD/MM/YYYY')}
                                    </p>
                                  </div>
                                  <div className='h-[2px] w-full bg-[#f1f4fb]'></div>
                                  <div className='my-2 mt-3 flex w-full justify-between'>
                                    <p>Hotline</p>
                                    <p className='text-[#0090F0]'>1900 299 232</p>
                                  </div>
                                  <div className='h-[2px] w-full bg-[#f1f4fb]'></div>
                                </div>
                              </div>
                            )}

                          {(type == 1 ||
                            type == 3 ||
                            type == 5 ||
                            (type == 4 && giftTransaction?.eGiftCode)) &&
                          !!eGift ? (
                            <AvaiableGift.Info
                              intro={
                                giftTransaction?.thirdPartyContent
                                  ? giftTransaction.thirdPartyContent
                                  : ''
                              }
                            />
                          ) : (
                            <DeliveringGift.Info data={data} />
                          )}
                        </ScrollArea>
                      </Tabs.TabPane>
                      <Tabs.TabPane tab='Điều kiện sử dụng' key='2'>
                        <ScrollArea style={{ height: '380px' }}>
                          <RenderHTML
                            string={`${
                              giftTransaction?.thirdPartyNote ? giftTransaction.thirdPartyNote : ''
                            }`}
                          />
                        </ScrollArea>
                      </Tabs.TabPane>
                      <Tabs.TabPane tab='Địa điểm' key='3'>
                        <div className='h-[380px] w-full'>
                          <Location office={giftTransaction?.office || []} />
                        </div>
                      </Tabs.TabPane>
                    </Tabs>
                  </TabsStyle>
                </div>
                {type == 3 &&
                  (!data?.eGift ||
                    (data?.eGift && new Date(data?.eGift?.expiredDate) > new Date())) && (
                    <DeliveringGift.Confirm handleChangeGift={() => handleChangeGift('delivery')} />
                  )}
                {type == 5 &&
                  (!data?.eGift ||
                    (data?.eGift && new Date(data?.eGift?.expiredDate) > new Date())) && (
                    <DeliveringGift.FillInInformation
                      fillInInformation={() => fillInInformation()}
                    />
                  )}
              </div>
              <ConfirmPopup
                isOpen={isOpen}
                handleClose={() => {
                  setIsOpen(false);
                }}
                handleSubmit={handleChangeGift}
                name={giftTransaction.giftName || ''}
                quantity={giftTransaction?.quantity || 1}
                point={giftTransaction.coin || 0}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default ModalDetailUseGift;
